<form [formGroup]="gOPolygonTypesForm" class="example-form settings-form" (ngSubmit)="onSubmit()">

    <mat-form-field>
        <mat-label>{{'FORM.gOPolygonTypesForm.title' | translate}}</mat-label>
        <input style="width:50%;" formControlName="title" matInput type="text" required >
    </mat-form-field>

    <mat-form-field >
        <mat-label>{{'FORM.gOPolygonTypesForm.borderColorName' | translate}}</mat-label>
        <input matInput formControlName="borderColorName" value="{{borderColorNameData}}" readonly/>
        <ngx-colors
          class="suffix"
          matSuffix
          ngx-colors-trigger
          [hideTextInput]="false"
          [format]="'hex'"
          formControlName="borderColorName"
        ></ngx-colors>
        <mat-error *ngIf="gOPolygonTypesForm.controls['borderColorName'].hasError('invalidColor')" > The color is invalid. </mat-error>
    </mat-form-field>

    <!-- <mat-form-field>
        <mat-label>{{'FORM.gOPolygonTypesForm.borderColorName' | translate}}</mat-label>
        <input formControlName="borderColorName" matInput type="color" >
        <div style="display:none;" *ngIf="data.data"><p >{{data.data.borderColorName}}</p></div>
    </mat-form-field>

    <mat-form-field>
        <mat-label>{{'FORM.gOPolygonTypesForm.fillOpacity' | translate}}</mat-label>
        <input formControlName="borderOpacity" id="opacityBorderNumber" style="width:100%;" type="range" name="opacity" min="0" max="1" step="0.01" [value]="borderOpacity" oninput="amount.value = opacityBorderNumber.value" >
        <input formControlName="borderOpacity" matInput id="amount" type="number" [value]="borderOpacity" min="0" max="1" step="0.01" oninput="opacityBorderNumber.value=amount.value" />        
        <p style="display:none;">{{newBordervalue}}</p>
    </mat-form-field> -->

    <mat-form-field>
        <mat-label>{{ 'FORM.gOPolygonTypesForm.borderWidth' | translate }}</mat-label>
        <button type="button" mat-icon-button matPrefix (click)="lessBorderWidth()">
            <mat-icon>remove</mat-icon>
        </button>
        <input matInput type="number" formControlName="borderWidth" min="0" step="1">
        <button type="button" mat-icon-button matSuffix (click)="addBorderWidth()">
            <mat-icon>add</mat-icon>
        </button>
    </mat-form-field>

    <!-- <mat-form-field>
        <mat-label>{{'FORM.gOPolygonTypesForm.fillColorName' | translate}}</mat-label>
        <input formControlName="fillColorName" matInput type="color" >
        <div style="display:none;" *ngIf="data.data"><p >{{data.data.fillColorName}}</p></div>
    </mat-form-field>

    <mat-form-field>
        <mat-label>{{'FORM.gOPolygonTypesForm.fillOpacity' | translate}}</mat-label>
        <input formControlName="fillOpacity" id="opacityFillNumber"style="width:100%;" type="range" name="opacity" min="0" max="1" step="0.01" oninput="amount.value = opacityFillNumber.value" >
        <input formControlName="fillOpacity" matInput id="amount" type="number" [value]="fillColorNameOpacity" min="0" max="1" step="0.01" oninput="opacityFillNumber.value=amount.value" />
        <p style="display:none;">{{newFillvalue}}</p>
    </mat-form-field> -->

    <mat-form-field >
        <mat-label>{{'FORM.gOPolygonTypesForm.fillColorName' | translate}}</mat-label>
        <input matInput formControlName="fillColorName" value="{{fillColorNameData}}" readonly/>
        <ngx-colors
          class="suffix"
          matSuffix
          ngx-colors-trigger
          [hideTextInput]="false"
          [format]="'hex'"
          formControlName="fillColorName"
        ></ngx-colors>
        <mat-error *ngIf="gOPolygonTypesForm.controls['fillColorName'].hasError('invalidColor')" > The color is invalid. </mat-error>
    </mat-form-field>

    <mat-slide-toggle class="example-margin slide-toggle-text m-1" formControlName="testInterval">
        {{'FORM.gOPolygonTypesForm.testInterval' | translate}}
    </mat-slide-toggle>

    <mat-slide-toggle class="example-margin slide-toggle-text m-1" formControlName="notificationChannel">
        {{'FORM.gOPolygonTypesForm.notificationChannel' | translate}}
    </mat-slide-toggle>

    <mat-slide-toggle class="example-margin m-1 slide-toggle-text" formControlName="usageInformation">
        {{'FORM.gOPolygonTypesForm.usageInformation' | translate}}
    </mat-slide-toggle>

   <div>
        <button class="my-4 first-stt-btn w-100" mat-raised-button type="submit" 
        [disabled]="gOPolygonTypesForm.invalid || updateRight || gOPolygonTypesForm.controls['fillColorName'].hasError('invalidColor') || gOPolygonTypesForm.controls['borderColorName'].hasError('invalidColor')">   
            {{ 'FORM.BTN_SAVE' | translate }}
        </button>

        <button [disabled]="gOPolygonTypesForm.invalid || deleteRight" class="w-100 second-stt-btn mb-2" style="float:inline-end;" mat-button (click)="onDelete()">
            {{ 'FORM.BTN_DELETE' | translate }}
        </button>
   </div>
</form>

<ng-template injectComp></ng-template>